// src/contexts/SupabaseContext.tsx
import {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from "react";
import { createClient, SupabaseClient, Session } from "@supabase/supabase-js";

const SupabaseContext = createContext<
  | {
      supabase: SupabaseClient;
      session: Session | null;
      loading: boolean;
    }
  | undefined
>(undefined);

const supabase: SupabaseClient = createClient(
  "https://zsqedtyyjncrcqilxqfe.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpzcWVkdHl5am5jcmNxaWx4cWZlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDAyOTc2NDAsImV4cCI6MjA1NTg3MzY0MH0.O07tLaD7HoSYd8i5C0PzPTlRgx1i5nEkhD3o0mzeLuw"
);

export function SupabaseProvider({ children }: { children: ReactNode }) {
  const [session, setSession] = useState<Session | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    // Properly type the response from getSession
    supabase.auth.getSession().then(({ data, error }) => {
      if (error) {
        console.error("Error getting session:", error);
        setSession(null);
      } else {
        setSession(data.session);
      }
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange(
      (_event: string, session: Session | null) => {
        setSession(session);
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      }
    );

    return () => subscription.unsubscribe();
  }, []);

  return (
    <SupabaseContext.Provider value={{ supabase, session, loading }}>
      {children}
    </SupabaseContext.Provider>
  );
}

export const useSupabase = () => {
  const context = useContext(SupabaseContext);
  if (context === undefined) {
    throw new Error("useSupabase must be used within a SupabaseProvider");
  }
  return context;
};
